// Veteran Topic 2 — Divergence (RSI/MACD). Notes + infographics (scenes in scenes/advanced.jsx).
export default {
  title: 'Divergence (RSI/MACD)',
  summary: 'When price and the indicator stop agreeing — an early warning.',
  subtopics: [
    { title: 'What It Is', scene: 'divWhat', cards: [
      { icon: '🙃', title: 'Two things disagree', body: 'Divergence is when price goes one way but the RSI or MACD goes the other way.' },
      { icon: '📊', title: 'RSI and MACD', body: 'They measure momentum — how strong the push is. They sit in a small window under the chart.' },
      { icon: '😮‍💨', title: 'Getting weaker', body: 'Price makes a new high, but the push behind it is weaker. Like a runner slowing down.' },
      { icon: '⚠️', title: 'A warning light', body: 'It hints the trend may slow or turn. It is not an entry by itself.' },
    ] },
    { title: 'Bullish & Bearish', scene: 'divBB', cards: [
      { icon: '🔴', title: 'Bearish divergence', body: 'Price: higher high. RSI/MACD: lower high. Price may fall.' },
      { icon: '🟢', title: 'Bullish divergence', body: 'Price: lower low. RSI/MACD: higher low. Price may rise.' },
      { icon: '📏', title: 'Connect the tops (or bottoms)', body: 'Draw a line on price and a line on the indicator. If they point different ways, that is divergence.' },
      { icon: '📍', title: 'Best at key levels', body: 'Divergence at a big resistance or support is much stronger.' },
    ] },
    { title: 'Confirming the Signal', scene: 'divConfirm', cards: [
      { icon: '⏳', title: 'Wait', body: 'Do not trade the divergence alone.' },
      { icon: '💥', title: 'Look for a structure break', body: 'For bearish divergence, wait for a candle to close below the last higher low.' },
      { icon: '🕯️', title: 'Candle signals help', body: 'An engulfing or pinbar at the level adds confirmation.' },
      { icon: '🟡', title: 'Gold example', body: 'Gold makes a higher high at 2,455 with RSI lower. Then it closes below 2,405 (last HL). Now a sell idea makes sense.' },
    ] },
    { title: 'False Divergence', scene: 'divFalse', cards: [
      { icon: '🏃', title: 'Strong trends ignore it', body: 'In a powerful trend, divergence can appear many times while price keeps going.' },
      { icon: '🔁', title: 'It can repeat', body: 'One divergence, then another, then another — and still no reversal.' },
      { icon: '🔭', title: 'Small timeframes lie more', body: 'M1/M5 divergence fails often. Use H1–D1.' },
      { icon: '🛑', title: 'Always use a stop', body: 'If structure does not break, there is no trade. If you are in, keep a stop loss.' },
    ] },
  ],
};
